import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Layout from "./Layout";

// Pages publiques
import Accueil from "./pages/Accueil";
import APropos from "./pages/APropos";
import Projets from "./pages/Projets";
import ProjectDetails from "./pages/ProjectDetails";
import Prefinancements from "./pages/Prefinancements";
import CampaignDetails from "./pages/CampaignDetails";
import Services from "./pages/Services";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";
import Login from "./pages/Login";

// Pages admin
import Dashboard from "./pages/Dashboard";
import AdminProjects from "./pages/AdminProjects";
import AdminCampaigns from "./pages/AdminCampaigns";
import AdminContributions from "./pages/AdminContributions";
import AdminLots from "./pages/AdminLots";
import AdminTeam from "./pages/AdminTeam";
import AdminBlog from "./pages/AdminBlog";
import AdminMessages from "./pages/AdminMessages";
import AdminServices from "./pages/AdminServices";
import AdminSettings from "./pages/AdminSettings";
import AdminHomeConfig from "./pages/AdminHomeConfig";
import AdminManagement from "./pages/AdminManagement";
import InitAdmin from "./pages/InitAdmin";
import AcceptInvitation from "./pages/AcceptInvitation";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30000,
    },
  },
});

function PageWrapper({ children }) {
  return <Layout>{children}</Layout>;
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/" element={<Navigate to="/accueil" replace />} />
          
          {/* Pages publiques avec Layout */}
          <Route path="/accueil" element={<PageWrapper><Accueil /></PageWrapper>} />
          <Route path="/apropos" element={<PageWrapper><APropos /></PageWrapper>} />
          <Route path="/projets" element={<PageWrapper><Projets /></PageWrapper>} />
          <Route path="/projectdetails" element={<PageWrapper><ProjectDetails /></PageWrapper>} />
          <Route path="/prefinancements" element={<PageWrapper><Prefinancements /></PageWrapper>} />
          <Route path="/campaigndetails" element={<PageWrapper><CampaignDetails /></PageWrapper>} />
          <Route path="/services" element={<PageWrapper><Services /></PageWrapper>} />
          <Route path="/blog" element={<PageWrapper><Blog /></PageWrapper>} />
          <Route path="/blogpost" element={<PageWrapper><BlogPost /></PageWrapper>} />
          <Route path="/contact" element={<PageWrapper><Contact /></PageWrapper>} />
          <Route path="/login" element={<PageWrapper><Login /></PageWrapper>} />
          
          {/* Pages admin avec Layout */}
          <Route path="/dashboard" element={<PageWrapper><Dashboard /></PageWrapper>} />
          <Route path="/adminprojects" element={<PageWrapper><AdminProjects /></PageWrapper>} />
          <Route path="/admincampaigns" element={<PageWrapper><AdminCampaigns /></PageWrapper>} />
          <Route path="/admincontributions" element={<PageWrapper><AdminContributions /></PageWrapper>} />
          <Route path="/adminlots" element={<PageWrapper><AdminLots /></PageWrapper>} />
          <Route path="/adminteam" element={<PageWrapper><AdminTeam /></PageWrapper>} />
          <Route path="/adminblog" element={<PageWrapper><AdminBlog /></PageWrapper>} />
          <Route path="/adminmessages" element={<PageWrapper><AdminMessages /></PageWrapper>} />
          <Route path="/adminservices" element={<PageWrapper><AdminServices /></PageWrapper>} />
          <Route path="/adminsettings" element={<PageWrapper><AdminSettings /></PageWrapper>} />
          <Route path="/adminhomeconfig" element={<PageWrapper><AdminHomeConfig /></PageWrapper>} />
          <Route path="/adminmanagement" element={<PageWrapper><AdminManagement /></PageWrapper>} />
          <Route path="/initadmin" element={<PageWrapper><InitAdmin /></PageWrapper>} />
          <Route path="/acceptinvitation" element={<PageWrapper><AcceptInvitation /></PageWrapper>} />
          
          {/* Fallback */}
          <Route path="*" element={<Navigate to="/accueil" replace />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
